import styled from 'styled-components';
import { Button as ButtonComponent } from '../../../shared/components/button';

export const Button = styled(ButtonComponent)`
  width: 100%;
  text-transform: uppercase;
  max-width: 700px;
  margin: 48px auto 80px;
`;
